"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importStar(require("styled-components"));
const LabelGroupPart_1 = __importDefault(require("../LabelGroupPart"));
const LabelItemWrapper_1 = require("../LabelItemWrapper");
function LabelItemGroup({ identifier, title, subtitle, parts = [], selectedLabelID, onSelectLabelID, selectedPartID, onSelectLabelPartID, }) {
    const [isDropdownVisible, setIsDropdownVisible] = (0, react_1.useState)(false);
    const [isTransitioning, setIsTransitioning] = (0, react_1.useState)(false);
    const containerRef = (0, react_1.useRef)(null);
    const isSelected = identifier === selectedLabelID;
    const onItemClick = (0, react_1.useCallback)(() => {
        onSelectLabelID(identifier);
        !isDropdownVisible && setIsTransitioning(true);
    }, [identifier, onSelectLabelID, isDropdownVisible]);
    (0, react_1.useEffect)(() => {
        if (isSelected && !isDropdownVisible) {
            setIsDropdownVisible(true);
        }
        else if (!isSelected && isDropdownVisible) {
            setIsDropdownVisible(false);
        }
    }, [isSelected, isDropdownVisible]);
    (0, react_1.useLayoutEffect)(() => {
        if (containerRef.current) {
            containerRef.current.style.height = isDropdownVisible
                ? `${containerRef.current.scrollHeight}px`
                : '0px';
        }
    }, [isDropdownVisible]);
    const handleTransitionEnd = () => {
        if (!isDropdownVisible) {
            setIsTransitioning(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(Container, { "data-e2e": 'LabelItemGroup_Container', children: [(0, jsx_runtime_1.jsxs)(StyledLabelItemWrapper, { isSelected: isSelected, hasBottomRadius: !isDropdownVisible && !isTransitioning, onClick: onItemClick, "data-e2e": 'LabelItemGroup_StyledLabelItemWrapper', children: [(0, jsx_runtime_1.jsxs)(Names, { "data-e2e": 'LabelItemGroup_Names', children: [(0, jsx_runtime_1.jsx)(PrimaryName, { isSelected: isSelected, "data-e2e": 'LabelItemGroup_PrimaryName', children: title }), subtitle && (0, jsx_runtime_1.jsxs)(LatinName, { "data-e2e": 'LabelItemGroup_LatinName', children: ["(", subtitle, ")"] })] }), (0, jsx_runtime_1.jsx)(StyledIcon, { name: isSelected ? ui_1.Icons.Arrow_Up : ui_1.Icons.Arrow_Down, width: 24, height: 24, isSelected: isSelected, "data-e2e": 'LabelItemGroup_StyledIcon' })] }, `${identifier}-${selectedLabelID}`), (0, jsx_runtime_1.jsx)(Group, { ref: containerRef, isVisible: isDropdownVisible, onTransitionEnd: handleTransitionEnd, "data-e2e": 'LabelItemGroup_Group', children: parts === null || parts === void 0 ? void 0 : parts.map(({ object }) => ((0, jsx_runtime_1.jsx)(LabelGroupPart_1.default, { identifier: object.identifier, title: object.name, selectedPartId: selectedPartID, onSelectLabelPartID: onSelectLabelPartID, "data-e2e": 'LabelItemGroup_LabelGroupPart' }, object.identifier))) })] }));
}
exports.default = (0, react_1.memo)(LabelItemGroup);
const Container = styled_components_1.default.div `
  position: relative;
  width: 100%;
  border-radius: 4px;
  box-shadow: 0px 0px 8px 0px #00000080;
  background: transparent;
`;
const StyledLabelItemWrapper = (0, styled_components_1.default)(LabelItemWrapper_1.LabelItemWrapper) `
  ${({ hasBottomRadius }) => !hasBottomRadius &&
    (0, styled_components_1.css) `
      border-radius: 4px 4px 0 0;
    }`}
`;
const Group = styled_components_1.default.div `
  overflow: hidden;
  border-radius: 0 0 4px 4px;
  transition: height 700ms ease-out;

  color: ${({ theme }) => theme.grasshopper.menuButtons.active};
  background: ${({ theme }) => theme.grasshopper.spotsPanel.selectedBackground};

  ${({ isVisible }) => isVisible &&
    (0, styled_components_1.css) `
      border-top: 1px solid
        ${({ theme }) => theme.grasshopper.spotsPanel.selectedBackground};
    }
        `};
`;
const PrimaryName = styled_components_1.default.div `
  line-height: 24px;
  font-weight: ${({ isSelected }) => (isSelected ? 700 : 400)};
`;
const LatinName = styled_components_1.default.div `
  font-size: 16px;
  line-height: 18.32px;
  margin: 8px 0 0;
`;
const Names = styled_components_1.default.div `
  padding: 0 8px;
`;
const StyledIcon = (0, styled_components_1.default)(ui_1.Icon) `
  margin: 0;
  padding: 8px;
  background-color: transparent;
  outline: none;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: color 700ms ease-out;

  color: ${({ isSelected, theme }) => isSelected
    ? theme.grasshopper.menuButtons.active
    : theme.grasshopper.menuButtons.idle};
`;
